import React from 'react'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

class ForPortAdminSideNavBar extends React.Component {
  componentDidMount() { }

  render() {
    return (
      <nav
        className="pcoded-navbar noprint"
        id="admin_menu"
      >
        <div className="pcoded-inner-navbar main-menu">
          <ul className="pcoded-item pcoded-left-item">
            <li className=" ">
              <Link to="/port-bookings">
                <span className="pcoded-micon edit">
                  <i className="icofont icofont-cart-alt"></i>
                </span>
                <span className="pcoded-mtext">{this.props.t('Bookings')}</span>
              </Link>
            </li>
            <li className="pcoded-hasmenu">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
              >
                <span className="pcoded-micon">
                  <i className="feather icon-map-pin"></i>
                </span>
                <span className="pcoded-mtext">{this.props.t('Reports')}</span>
              </a>
              <ul className="pcoded-submenu">
                <li className=" ">
                  <Link to="/daily-trip-report">
                    <span className="pcoded-mtext">{this.props.t('Daily trip report')}</span>
                  </Link>
                </li>
                <li className=" ">
                  <Link to="/daily-event-report">
                    <span className="pcoded-mtext">{this.props.t('dailyEventReport')}</span>
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}

export default withTranslation()(ForPortAdminSideNavBar)